import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from '../../../messages';
import Section from '../../../../components/Section';
import ControlContainer from '../../../../components/ControlContainer';
import P from '../../../../../../components/P';
import TugoAllBenefits from '../../TugoAllBenefits';
import InitDeclaration from '../../InitDeclaration';
import TugoFraudNotice from '../../TugoFraudNotice';
import WarningSection from './WarningSection';
import ElectronicConsentSection from './ElectronicConsentSection';
import CheckboxInput from './CheckboxInput';
import { appConfig } from '../../../../../../configureApp';

const VisitorsToCanadaSection = ({
  TPAName,
  carrier,
  showFraudNotice,
  showWarningMissingRequiredDocument,
  showWarningInvalidRequiredDocument,
  warningMissingRequiredDocument,
  showElectronicConsentDocument,
  electronicConsentDocument,
  emailAddress,
  errorEmails,
  signature,
  isMultipleClaimFor,
  isReadOnly,
  handleChange,
  intl,
}) => (
  <Section>
    <ControlContainer>
      <P>
        <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} id={messages.youAreAboutToSubmitYourClaimAnd.id} />
      </P>
      <TugoAllBenefits TPAName={TPAName} carrier={carrier} />
      {showFraudNotice === true && <InitDeclaration />}
      {showFraudNotice === false && <TugoFraudNotice />}

      <WarningSection
        showWarningMissingRequiredDocument={showWarningMissingRequiredDocument}
        showWarningInvalidRequiredDocument={showWarningInvalidRequiredDocument}
        warningMissingRequiredDocument={warningMissingRequiredDocument}
        isReadOnly={isReadOnly}
        handleChange={handleChange}
        intl={intl}
      />

      {showElectronicConsentDocument === true && (
        <ElectronicConsentSection
          electronicConsentDocument={electronicConsentDocument}
          emailAddress={emailAddress}
          errorEmails={errorEmails}
          signature={signature}
          isMultipleClaimFor={isMultipleClaimFor}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {showElectronicConsentDocument !== true && (
        <div className="row">
          <div className="form-group col-md-12">
            <CheckboxInput
              name="signature"
              checked={signature === true}
              onChange={handleChange('form.signature')}
              disabled={isReadOnly}
              message={messages.agreeTugo}
              messageId={messages.agreeTugo.id}
            />
          </div>
        </div>
      )}

      <P style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
        <FormattedMessage {...messages.clickSubmitClaim} id={messages.clickSubmitClaim.id} />
      </P>

      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.privacyStatement} id={messages.privacyStatement.id} />
          </P>
          <P style={{ fontStyle: 'italic' }}>
            <FormattedMessage {...messages.privacyStatementMessage1Tugo} id={messages.privacyStatementMessage1Tugo.id} />{' '}
            <a href={appConfig.privacyStatementUrl} target="_blank" rel="noopener noreferrer">
              <FormattedMessage {...messages.here} id={messages.here.id} />
            </a>.{' '}
            <FormattedMessage {...messages.privacyStatementMessage2Tugo} id={messages.privacyStatementMessage2Tugo.id} />
          </P>
        </ControlContainer>
      </Section>
    </ControlContainer>
  </Section>
);

VisitorsToCanadaSection.propTypes = {
  TPAName: PropTypes.any.isRequired,
  carrier: PropTypes.any.isRequired,
  showFraudNotice: PropTypes.bool.isRequired,
  showWarningMissingRequiredDocument: PropTypes.bool.isRequired,
  showWarningInvalidRequiredDocument: PropTypes.bool.isRequired,
  warningMissingRequiredDocument: PropTypes.string.isRequired,
  showElectronicConsentDocument: PropTypes.bool.isRequired,
  electronicConsentDocument: PropTypes.bool.isRequired,
  emailAddress: PropTypes.any.isRequired,
  errorEmails: PropTypes.any,
  signature: PropTypes.bool.isRequired,
  isMultipleClaimFor: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

VisitorsToCanadaSection.defaultProps = {
  errorEmails: null,
};

export default injectIntl(VisitorsToCanadaSection);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/VisitorsToCanadaSection.js